import Uploader from '@elem/compCommon/Uploader';
import styles from './index.module.scss';

interface PictureUploadProps {
    value?: string | null;
    onChange?: (url: string | null) => void;
}

const PictureUpload: React.FC<PictureUploadProps> = ({ value, onChange }) => {
    return (
        <div className={styles.uploadWrap}>
            <Uploader
                maxCount={1}
                size={10 * 1024 * 1024}
                types={['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'jpg', 'jpeg', 'png', 'gif', 'webp']}
                accept="image/*"
                value={value ? [value] : []}
                onChange={(urls) => onChange?.(urls[0] || null)}
            />
        </div>
    );
};

export default PictureUpload;
